module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-600.5a87f7c.woff";